export default {
  defaultRequestTimeOut: 30000,
  statusCode: {
    noResponse: 444
  },
  storageName: {
    token: 'token_access',
    userInfo: 'user_info',
    expiredAt: 'expired_at'
  },

  fetchError: {
    errorBE: "Something went wrong! Maybe server's having a problem"
  },
  error: {
    
  }
}